import { Typography } from "@material-ui/core";
import { get } from "lodash";
import moment from "moment";
import React from "react";
import { TextField, useTranslate } from "react-admin";

const Wrapper = ({ children }) => (
	<div
		style={{
			whiteSpace: "white-space",
			overflow: "hidden",
			maxWidth: 180,
			textOverflow: "ellipsis",
		}}
	>
		{children}
	</div>
);

const LandingField = ({ record, source, basePath, sortable, ...props }) => {
	const translate = useTranslate();
	if (get(record, "landing", null) !== null) {
		const option = get(record, "landing");
		return (
			<Wrapper>
				<Typography {...props} style={{ lineHeight: 1 }}>
					{option.name} {option.start_at && "("}
					{option.start_at !== null &&
						moment(option.start_at).format(translate("app.date_format.short"))}
					{option.end_at !== null && " - "}
					{option.end_at !== null &&
						moment(option.end_at).format(translate("app.date_format.short"))}
					{option.start_at !== null && ")"}
				</Typography>
			</Wrapper>
		);
	}
	return (
		<Wrapper>
			<TextField
				{...props}
				record={{
					...record,
					[source]: translate(
						`resources.bookmaker-channels.landing_opts.${get(
							record,
							"bookmaker_landing_type"
						)}`
					),
				}}
				source={source}
			/>
		</Wrapper>
	);
};
export default LandingField;
